import { NgModule } from '@angular/core';
import { PageMetaResolver } from '@spartacus/core';
import { CustomContentPageMetaResolver } from './custom-content-page-meta.resolver';
import { ShopsPageMetaResolver } from './shops-page-meta.resolver';
import { StaticPageMetaResolver } from './static-page-meta.resolver';

@NgModule({
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: CustomContentPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: ShopsPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: StaticPageMetaResolver,
      multi: true,
    },
  ],
})
export class ResolversModule {}
